module.exports = __webpack_public_path__ + "static/media/0323_IMG_FE_LES_MURS_PALOMINO_W_VPL2100_CHEVRON.a89a65de.png";